import React from "react";
import { Helmet } from "react-helmet";
import { matchPath, useLocation } from "react-router-dom";

// Browser-tab title for pages that don't set their own <Helmet> title, so the tab never keeps the previous page's title.
// A page's own <Helmet> title still wins: it mounts after this one, and react-helmet uses the last title.
// First match wins, so a fixed path ("/users/create") must come before a param path ("/users/:id").
const ROUTE_TITLES = [
  ["/career", "Careers"],
  ["/forgot-password", "Forgot Password"],
  ["/reset-password/:token", "Set New Password"],
  ["/unauthorized", "Unauthorized"],
  ["/saas-admin-dashboard", "Dashboard"],
  ["/admin/admin-dashboard", "Dashboard"],
  ["/:cid/saas-admin-dashboard", "Dashboard"],
  ["/:cid/dashboard", "Dashboard"],
  ["/:cid/profile", "My Profile"],
  ["/:cid/users/create", "Add Employee"],
  ["/:cid/users/view/:id", "View Employee"],
  ["/:cid/users/:id", "Edit Employee"],
  ["/:cid/departments/create", "Create Department"],
  ["/:cid/departments/edit", "Edit Department"],
  ["/:cid/employeejob/create", "Create Employment Status"],
  ["/:cid/employeejob/edit", "Edit Employment Status"],
  ["/:cid/crm-pipeline", "Pipeline"],
  ["/:cid/crm-action-queue", "Action Queue"],
  ["/:cid/settings", "Settings"],
  ["/:cid/company_shifts/create", "Create Company Shift"],
  ["/:cid/company_shifts/edit/:id", "Edit Company Shift"],
  ["/:cid/evaluation", "Performance Evaluation"],
  ["/:cid/teamevaluations", "Team Evaluations"],
  ["/:cid/all-users-evaluations", "All Employees' Evaluations"],
  ["/:cid/myevaluation", "My Evaluations"],
];

const PageTitle = () => {
  const { pathname } = useLocation();
  const match = ROUTE_TITLES.find(([pattern]) => matchPath(pattern, pathname));
  return (
    <Helmet>
      <title>{match ? `${match[1]} - Planit` : "Planit"}</title>
    </Helmet>
  );
};

export default PageTitle;
